//Types
import { DialogerTypes, DialogerTypesBreakPoints } from './useDialoger.type';

/**
 * A mapping of dialog types to breakpoints.
 */
export const dialogerTypeMap: DialogerTypesBreakPoints = {
  base: DialogerTypes.drawer,
  md: DialogerTypes.modal,
};
